import React, { useState } from "react";
import SimpleTable from "../../components/SimpleTable";
import { StatusLabel } from "../../components/StatusLabel";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import { Button, ListItemText } from "@material-ui/core";
import Time from "../../lithic/Moment";
import { startCase } from "lodash";
import SafeExternalLink from "../../lithic/SafeExternalLink";
import api from "../../api";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import InfoOutlineIcon from "@material-ui/icons/InfoOutlined";

const ExternalLink = ({ href, key }) => {
  if (!href) return <ListItemText key={key}>--</ListItemText>;

  return (
    <SafeExternalLink href={href}>
      {href.split("/")?.pop() ?? "External Link"}
    </SafeExternalLink>
  );
};

export const ApplicantVerifications = ({ verifications, refetch }) => {
  const [bypassVerificationId, setBypassVerificationId] = useState(null);
  const history = useHistory();
  const { id } = useParams();
  return (
    <>
      <SimpleTable
        headers={[
          "Name",
          "Status",
          "External URL",
          "Vendor",
          "Updated at",
          "Created at",
          "Actions"
        ]}
        rows={verifications}
        onClick={(verification) => {
          history.push(`/applicants/${id}/verifications/${verification.id}`);
        }}
        keyRowAttr="id"
        toCells={(verification) => [
          <ListItemText key={1}>{startCase(verification.name)}</ListItemText>,
          <StatusLabel key={2} status={verification.status} label=" " />,
          <ExternalLink key={3} href={verification.externalUrl} />,
          <ListItemText key={4}>{startCase(verification.vendor)}</ListItemText>,
          <Time key={5} d="(unset)" formatExact="MMM DD, YYYY HH:mm:ss">
            {verification.updatedAt}
          </Time>,
          <Time key={6} d="(unset)" formatExact="MMM DD, YYYY HH:mm:ss">
            {verification.createdAt}
          </Time>,
          <div key={7} className="flex gap-2 justify-end">
            {[
              "verified_income_verification",
              "combined_income_verification"
            ].includes(verification.name) ? (
              <Button
                variant="contained"
                color="primary"
                className="block"
                disabled={
                  ["finished", "finished_with_warnings", "pending"].includes(
                    verification.status
                  ) || verification.bypassDocumentVerificationEnabled
                }
                onClick={() => {
                  setBypassVerificationId(verification.id);
                }}
              >
                Bypass
              </Button>
            ) : null}
            {!verification.name.includes("credit_report") && (
              <Button
                variant="contained"
                color="primary"
                className="block"
                disabled={verification.status === "pending"}
                onClick={() => {
                  api
                    .restartVerifiedIncomeVerification({
                      verificationId: verification.id
                    })
                    .then(() => {
                      toast.success("Restarted verification back to pending");
                      refetch();
                    })
                    .catch((err) => {
                      toast.error(err.message);
                    });
                }}
              >
                Restart
              </Button>
            )}
            <Button
              variant="contained"
              color="primary"
              className="block"
              onClick={() => {
                history.push(
                  `/applicants/${id}/verifications/${verification.id}`
                );
              }}
            >
              View
            </Button>
          </div>
        ]}
      />
      <ConfirmationDialog
        title={
          <div className="max-w-[400px] flex flex-col items-center gap-4">
            <div className="flex items-center justify-center bg-red-50 rounded-full p-8">
              <InfoOutlineIcon
                className="text-red-500 text-[32px]"
                fontSize="large"
              />
            </div>
            <h3 className="text-xxl font-bold text-content-1000 text-center">
              Are you sure you want to bypass income verification?
            </h3>
          </div>
        }
        open={Boolean(bypassVerificationId)}
        onCancel={() => {
          setBypassVerificationId(null);
        }}
        onConfirm={() => {
          api
            .bypassIncomeVerification({
              verificationId: bypassVerificationId
            })
            .then(() => {
              toast.success("Bypassed verification");
              refetch();
            })
            .catch((err) => {
              toast.error(err.message);
            })
            .finally(() => {
              setBypassVerificationId(null);
            });
        }}
        cancelProps={{ children: "Cancel", className: "w-[150px] h-[50px]" }}
        confirmProps={{ children: "Bypass", className: "w-[150px] h-[50px]" }}
        actionsContainerClassName="flex !p-6"
      >
        <div className="max-w-[400px] rounded-xl bg-red-50 py-4 px-8 text-red-600 font-medium text-sm space-y-3">
          <li>This action can`t be undone</li>
          <li>
            All income data will be deleted, and the user will need to re-enter
            the self-attested income
          </li>
          <li>The income verification part will be skipped</li>
        </div>
      </ConfirmationDialog>
    </>
  );
};
